import { thousandSeparator as addSeparator } from "../utils/thousandSeparator";

export type CustomMaskRenderArgs = {
  value: string;
  className: string;
  font: string;
  onClick: () => void;
};

export const measureNumberWidth = (
  value: string,
  font: string,
  thousandSeparator: boolean = false,
): number => {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  if (!context) return 0;
  context.font = font;
  const numberValue: number = parseFloat(value);
  const currentWidth = context.measureText(
    thousandSeparator ? addSeparator(numberValue).toString() : value,
  ).width;
  const zeroWidth = context.measureText("0").width;
  return currentWidth > zeroWidth ? currentWidth : zeroWidth;
};
